import { GET_ALL_PENDING_TABLES, DELETE_PENDING_TABLE, ADD_PENDING_TABLE } from "../ActionTypes/pendingTableTypes";

const initialState = {
  pendingTables: [],
  lockedTables: [],
};

const pendingTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_PENDING_TABLES:
      return {
        ...state,
        pendingTables: action.payload,
      };

      case "ADD_PENDING_TABLE":
        return {
          ...state,
          [action.payload.tableNumber]: { items: action.payload.items, status: "locked" },
        };
  
      case "DELETE_PENDING_TABLE":
        const updatedState = { ...state };
        delete updatedState[action.payload];
        localStorage.setItem("pendingTables", JSON.stringify(updatedState));
        return updatedState;



      // case ADD_PENDING_TABLE:
      // return {
      //   ...state,
      //   [action.payload.tableNumber]: { items: action.payload.items, status: "locked" },
      // };
    // case DELETE_PENDING_TABLE:
    //   return {
    //     ...state,
    //     pendingTables: state.pendingTables.filter(
    //       (table) => table.tableNumber !== action.payload
    //     ),
    //   };

      case "LOCK_PENDING_TABLE":
      return {
        ...state,
        lockedTables: [...state.lockedTables, action.payload],
        pendingTables: state.pendingTables.filter(
          (table) => table.tableNumber !== action.payload.tableNumber
        ),
      };

    case "UNLOCK_PENDING_TABLE":
      return {
        ...state,
        pendingTables: [...state.pendingTables, state.lockedTables.find((table) => table.tableNumber === action.payload)],
        lockedTables: state.lockedTables.filter((table) => table.tableNumber !== action.payload),
      };

    default:
      return state;
  }
};

export default pendingTableReducer;
